// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-terms-history-row {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
}
.terms-history-modal {
  width: 600px !important;
}
.terms-applies-main-text {
  font-family: Montserrat;
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}
.review-terms-selected-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
.terms-plan-history-table-row {
  margin-top: 1.5rem;
}
.terms-plan-history-table {
  width: 100% !important;
}
.terms-final-close-button-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
}
.terms-close-button {
  width: 81px;
  height: 40px;
  background: #e8e8e8;
  cursor: pointer;
}
.terms-close-button:hover {
  background: #e8e8e8 !important;
}
.terms-close-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}
.terms-plan-history-table .ant-table-tbody > tr > td {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
  border-bottom: 1px solid #c5c5c5;
}
.terms-plan-history-table .ant-table-thead > tr > th:not(:first-child) {
  text-align: left !important;
}
.terms-plan-history-table.ant-table-wrapper .ant-table {
  max-height: 50vh !important;
  overflow-y: auto;
}
@media (min-width: 376px) and (max-width: 425px) {
  .terms-applies-main-text {
    font-size: 18px !important;
  }
  .review-terms-selected-text {
    font-size: 16px !important;
    line-height: 19px !important;
  }
  .payment-terms-history-row {
    gap: 5px !important;
  }
  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {
    color: #fff;
    background-color: #000;
    font-size: 15px;
  }
  .terms-plan-history-table .ant-table-tbody > tr > td {
    font-size: 15px !important;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .terms-applies-main-text {
    font-size: 16px !important;
  }
  .review-terms-selected-text {
    font-size: 15px !important;
    line-height: 19px !important;
  }
  .payment-terms-history-row {
    gap: 5px !important;
  }
  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {
    color: #fff;
    background-color: #000;
    font-size: 13px;
  }
  .terms-plan-history-table .ant-table-tbody > tr > td {
    font-size: 14px !important;
  }
  .terms-close-button {
    height: 35px !important;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .terms-plan-history-table .ant-table-tbody > tr > td {
    font-size: 12px !important;
  }
  .terms-close-button {
    height: 35px !important;
  }
  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {
    font-size: 12px !important;
  }
  .terms-plan-history-table .ant-table-tbody > tr > td {
    font-size: 12px !important;
  }
  .terms-close-button-text {
    font-size: 14px !important;
  }
  .terms-final-close-button-row {
    margin-top: 1rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/view-payment-terms/ViewTermsPlan.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".payment-terms-history-row {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  gap: 10px;\n}\n.terms-history-modal {\n  width: 600px !important;\n}\n.terms-applies-main-text {\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 1.4rem;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.review-terms-selected-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n.terms-plan-history-table-row {\n  margin-top: 1.5rem;\n}\n.terms-plan-history-table {\n  width: 100% !important;\n}\n.terms-final-close-button-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n.terms-close-button {\n  width: 81px;\n  height: 40px;\n  background: #e8e8e8;\n  cursor: pointer;\n}\n.terms-close-button:hover {\n  background: #e8e8e8 !important;\n}\n.terms-close-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.terms-plan-history-table .ant-table-tbody > tr > td {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n  border-bottom: 1px solid #c5c5c5;\n}\n.terms-plan-history-table .ant-table-thead > tr > th:not(:first-child) {\n  text-align: left !important;\n}\n.terms-plan-history-table.ant-table-wrapper .ant-table {\n  max-height: 50vh !important;\n  overflow-y: auto;\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .terms-applies-main-text {\n    font-size: 18px !important;\n  }\n  .review-terms-selected-text {\n    font-size: 16px !important;\n    line-height: 19px !important;\n  }\n  .payment-terms-history-row {\n    gap: 5px !important;\n  }\n  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {\n    color: #fff;\n    background-color: #000;\n    font-size: 15px;\n  }\n  .terms-plan-history-table .ant-table-tbody > tr > td {\n    font-size: 15px !important;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .terms-applies-main-text {\n    font-size: 16px !important;\n  }\n  .review-terms-selected-text {\n    font-size: 15px !important;\n    line-height: 19px !important;\n  }\n  .payment-terms-history-row {\n    gap: 5px !important;\n  }\n  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {\n    color: #fff;\n    background-color: #000;\n    font-size: 13px;\n  }\n  .terms-plan-history-table .ant-table-tbody > tr > td {\n    font-size: 14px !important;\n  }\n  .terms-close-button {\n    height: 35px !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .terms-plan-history-table .ant-table-tbody > tr > td {\n    font-size: 12px !important;\n  }\n  .terms-close-button {\n    height: 35px !important;\n  }\n  .terms-plan-history-table.ant-table-wrapper .ant-table-thead > tr > th {\n    font-size: 12px !important;\n  }\n  .terms-plan-history-table .ant-table-tbody > tr > td {\n    font-size: 12px !important;\n  }\n  .terms-close-button-text {\n    font-size: 14px !important;\n  }\n  .terms-final-close-button-row {\n    margin-top: 1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
